<template>
  <div class="container">
    <div class="panel panel-default">
      <div class="panel-body" id="imput-form">
        <div class="confirmcode">
          <h2>確認コード入力</h2>
          <form @submit.prevent="confirm">
            <p>
              <label for="form_1" class="control-label">メールアドレス</label>
              <input type="text" class="form-control" v-model="userId" required>
           </p>
            <p>
              <label for="form_1" class="control-label">確認コード</label>
              <input type="text" class="form-control" v-model="confirmationCode" required>
            </p>
            <p align="right">
            <button class="btn btn-outline-secondary">確認</button>
            </p>
          </form>
          <router-link to="/">ログイン</router-link>
          <router-link to="/signup">ユーザー登録</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Confirm",
  data() {
    return {
      userId: "",
      confirmationCode: ""
    };
  },
  methods: {
    confirm() {
      this.$cognito
        .confirmation(this.userId, this.confirmationCode)
        .then(result => {
          this.$router.replace("/");
        })
        .then(err => {
          this.error = err;
        });
    }
  }
};
</script>

<style scoped >
h2 {
  text-align: center;
}
div {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Confirmcode.vue